import { render, staticRenderFns } from "./SafeguardingMetrics.vue?vue&type=template&id=4907f05e&scoped=true&"
import script from "./SafeguardingMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./SafeguardingMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SafeguardingMetrics.vue?vue&type=style&index=0&id=4907f05e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4907f05e",
  null
  
)

export default component.exports